<template>
  <div :key="key" class="address-custom">
    <el-form-item>
      <div class="select">
        <el-form-item prop="province">
          <el-select
            v-model="ruleForm.province"
            filterable
            placeholder="省份"
            @change="chosePro"
          >
            <el-option
              v-for="(item, index) in provinceOps"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="city_id">
          <el-select
            v-model="ruleForm.city_id"
            filterable
            placeholder="城市"
            @change="choseCity"
          >
            <el-option
              v-for="(item, index) in cityOps"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="area_name">
          <el-select
            v-model="ruleForm.area_name"
            filterable
            placeholder="区域"
            @change="choseArea"
          >
            <el-option
              v-for="(item, index) in areaOps"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="plate_id">
          <el-select
            v-model="ruleForm.plate_id"
            filterable
            placeholder="板块"
            @change="chosePlate"
          >
            <el-option
              v-for="(item, index) in plateOps"
              :key="index"
              :label="item.plate_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form-item>
    <el-form-item style="margin-top: 10px">
      <el-input
        type="text"
        placeholder="例如xx路xx楼xx号"
        v-model="ruleForm.address"
        :maxlength="100"
        show-word-limit
        @input="choseAddress"
      ></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "AddressCustom",
  inheritAttrs: false,
  props: {
    value: {
      default: "",
      type: [String, Number, Array],
    },
  },

  data() {
    return {
      key: `AddressCustom-${Math.random().toString(36).slice(2)}`,
      ruleForm: {
        province: "",
        city_id: "",
        area_name: "",
        plate_id: "",
        address: "",
        city_name: "",
        plate_name: "",
      },

      provinceOps: [],
      cityOps: [],
      areaOps: [],
      plateOps: [],
      provinceCity: [], //所有省市集合
      provinceArea: [], //所有区域集合
      id: "",
      newaddress: "",
      projectChoArr: [], //选择项目时带有的省市区
    };
  },
  watch: {
    value: {
      handler(val, old) {
        this.init(val);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      },
    },
  },
  mounted() {
    // this.init();
  },
  methods: {
    async init(val) {
      if (val[0]) {
      
        this.ruleForm = {
          province: val[0],
          city_id: val[1],
          area_name: val[2],
          plate_id: val[3]?val[3]*1:"",
          address: val[4],
          city_name: "",
          plate_name: "",
        };
      }else{
        this.ruleForm = {
            province: "",
            city_id: "",
            area_name: "",
            plate_id: "",
            address: "",
            city_name: "",
            plate_name: "",
          };
      }

      const res = await this.$axios.post("/recruitment/config/province_city", {
        type: 1,
      });
      this.provinceCity = res.data.items;

      for (let i = 0; i < this.provinceCity.length; i++) {
        if (this.provinceCity[i].province) {
          this.provinceOps.push(this.provinceCity[i].province);
        }
        if (this.provinceCity[i].province == this.ruleForm.province) {
          this.cityOps = this.provinceCity[i].city_list;
        }
      }
      this.provinceOps = Array.from(new Set(this.provinceOps));
      this.cityOps = Array.from(new Set(this.cityOps));

      if (this.ruleForm.city_id) {
        const areaPlateres = await this.$axios.post(
          "/recruitment/config/area_plate?id=" + this.ruleForm.city_id
        );

        this.provinceArea = areaPlateres.data.items;
        let arr = [];
        for (let i = 0; i < this.provinceArea.length; i++) {
          if (this.provinceArea[i].area) {
            arr.push(this.provinceArea[i].area);
          }
          if (this.provinceArea[i].area == this.ruleForm.area_name) {
         
            this.plateOps = this.provinceArea[i].plate_list;
          }
        }
        this.areaOps = arr;
      }
      
    },
    choseAddress(e) {
      this.setValue();
    },
    chosePro(e) {
      this.$forceUpdate();
      //选择省份同时置空
      this.cityOps = [];
      this.ruleForm.city_id = "";
      this.areaOps = [];
      this.ruleForm.area_name = "";
      this.plateOps = [];
      this.ruleForm.plate_id = "";
      this.ruleForm.city_name = "";
      this.ruleForm.plate_name = "";
      if (this.provinceCity.length > 0) {
        for (let i = 0; i < this.provinceCity.length; i++) {
          if (this.provinceCity[i].province == e) {
            this.cityOps = this.provinceCity[i].city_list;
          }
        }
      }
      this.setValue();
    },
    choseCity(e) {
      this.$forceUpdate();
      this.areaOps = [];
      this.ruleForm.area_name = "";
      this.plateOps = [];
      this.ruleForm.plate_id = "";
      this.ruleForm.plate_name = "";
      this.$axios.post("/recruitment/config/area_plate?id=" + e).then((res) => {
        this.provinceArea = res.data.items;
        let arr = [];
        for (let i = 0; i < this.provinceArea.length; i++) {
          if (this.provinceArea[i].area) {
            arr.push(this.provinceArea[i].area);
          }
        }
        this.areaOps = arr;
      });
      this.setValue();
    },
    choseArea(e) {
      this.$forceUpdate();
      this.plateOps = [];
      this.ruleForm.plate_id = "";
      this.ruleForm.plate_name = "";
      if (this.provinceArea.length > 0) {
        for (let i = 0; i < this.provinceArea.length; i++) {
          if (this.provinceArea[i].area == e) {
            this.plateOps = this.provinceArea[i].plate_list;
          }
        }
      }
      this.setValue();
    },
    chosePlate(e) {
      this.$forceUpdate();
      this.ruleForm.plate_name = this.plateOps.find(
        (item) => item.id == e
      ).plate_name;
      this.setValue();
    },
    setValue() {
      this._value = [
        this.ruleForm.province,
        this.ruleForm.city_id,
        this.ruleForm.area_name,
        this.ruleForm.plate_id,
        this.ruleForm.address,
      ];
    },
  },
};
</script>

<style lang="scss">
.address-custom {
  .select {
    .el-form-item {
      width: 100px;
      display: inline-block;
    }
    .el-form-item + .el-form-item {
      margin-left: 5px;
    }
  }
}
</style>
